var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrap"},[_c('el-form',{staticClass:"demo-ruleForm login-container",attrs:{"label-width":"5px"}},[_c('img',{staticStyle:{"width":"256px","margin-left":"2.5%"},attrs:{"src":require("../assets/img/SignSuccess_202110091517.png")}}),_vm._v(" "),_c('h1',[_vm._v("报名成功")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f380b4d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/RegSuccess.vue
// module id = null
// module chunks = 